const LEGACY_LOCAL_STORAGE_KEYS = ['hawk-user-id', 'guid', 'guest_visit_count']

export function cleanupLegacyClientStorage() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return
  }

  try {
    LEGACY_LOCAL_STORAGE_KEYS.forEach(key => localStorage.removeItem(key))

    const keysToRemove = []
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key && key.startsWith('lookport:task-device:')) {
        keysToRemove.push(key)
      }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key))

    sessionStorage.removeItem('shoppingGoodsAndAddress')
    localStorage.removeItem('MTSTestingCookiesAccepted')
  } catch {
    // ignore
  }
}
